export default __webpack_public_path__ + "assets/favicon-light.b678e78cba6c69cf6537b7245dfdea1c.svg";